import { useMemo } from 'react';
import { useRootStore } from 'app/contexts/RootStoreContext';
import { useMspCustomers } from 'users/new-user-management/hooks/reactQuery/useMspCustomers';

export const useGetCustomersDescription = (tableData) => {
  const { usersStore } = useRootStore();

  const { fetchMspCustomersData } = useMspCustomers();
  const { data: customersData, isLoading: isCustomersDataLoading } = fetchMspCustomersData({
    enabled: !!usersStore?.rootStore?.appStore?.isKeyCloakManagement,
  });
  
  const tableDataToDisplay = useMemo(() => {
    if (usersStore?.rootStore?.appStore?.isKeyCloakManagement) {
      if (tableData && customersData) {
        return tableData?.map((row) => {
          const customer = customersData?.find((customer) => customer.id === row.customerId);
          if (customer) {
            return {
              ...row,
              customerName: customer?.name,
              description: customer?.description,
            };
          }
          return row;
        });
      }
    } else return tableData;
  }, [usersStore?.rootStore?.appStore?.isKeyCloakManagement, tableData, customersData]);

  return {
    tableDataToDisplay,
    isCustomersDataLoading,
  };
};
